import { IOption } from '@utils/interfaces';

export const statusOptions: IOption[] = [
  { value: 'pending', label: 'Pendente' },
  { value: 'active', label: 'Ativo' },
  { value: 'canceled', label: 'Cancelado' },
  { value: 'contract_sent', label: 'Contrato enviado' },
];
